var sw = sw || {};


// Home fold slider 
//-----------------------------------------------------------------
sw.foldSlider = function() {

    var $slider = $('.js_foldSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        fade: true,
        speed: 1000,
        infinite: true,
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slide: '.fold__item',
        appendDots: $('.fold__dots'),
        appendArrows: $('.fold__arrows'),
        touchThreshold: 12,
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
    });

};

// Kupujte po kolekciji
//-----------------------------------------------------------------
sw.foldGallery = function() {

    var $slider = $('.js_foldGallery').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        // focusOnSelect: false,
        // accessibility: false,
        infinite: false,
        centerMode: false,
        // centerPadding: 0,
        touchThreshold: 12,
        slide: '.gallery__item',
        // appendDots: $('.fold__dots'),
        // appendArrows: $('.gallery__arrows'),
        prevArrow: '<a class="gallery__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="gallery__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)',
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3
                 
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2   
                }
            },          
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }           
        ]
    });
};


// sw.testimonialsSlider = function() {

//     var $slider = $('.js_testimonialsSlider').removeClass('visuallyhidden');

//     if (!$slider.length) {
//         return;
//     }

//     $slider.slick({
//         mobileFirst: true,
//         autoplay: true,
//         autoplaySpeed: 5000,
//         arrows: false,
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         focusOnSelect: true,
//         accessibility: false,
//         centerMode: true,
//         centerPadding: 0,
//         slide: '.testimonials__item',
//         appendDots: $('.testimonials__dots'),
//          responsive: [
//             {
//               breakpoint: 1024,
//               settings: {
//                 slidesToShow: 2
//               }
//             }
//         ]
       
//     });

// };


$(document).ready(function (){
    sw.foldSlider();
    sw.foldGallery();
    // sw.testimonialsSlider();
});